import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { NavService } from 'src/app/services/nav.service';
import { ActivatedRoute, Router } from '@angular/router';

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { VRM, VRMSchema } from '@pixiv/three-vrm';
declare const JEEFACETRANSFERAPI: any;

@Component({
  selector: 'app-avatar-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class AvatarConfirmComponent implements OnInit, OnDestroy {
  @ViewChild('video', {static: true}) video: ElementRef;
  avatar: string;
  models = [
    '../../../assets/vrm/avatar1.vrm',
    '../../../assets/vrm/avatar2.vrm',
    '../../../assets/vrm/avatar3.vrm',
    '../../../assets/vrm/avatar4.vrm',
    '../../../assets/vrm/avatar5.vrm',
    '../../../assets/vrm/avatar6.vrm'
  ];
  isJeelizReady = false;
  // VRMのロード完了フラグ
  isModelLoaded = false;
  currentVrm: any;

  constructor(
    public auth: AuthService,
    private nav: NavService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.paramMap
      .subscribe(params => {
        this.avatar = params.get('avatar');
      });
    }

  ngOnInit() {
    setTimeout(() => {
      this.nav.hide();
    });

    // Jeelizを起動してVRMを読み込み
    this.initJeeliz();
    this.initVrm();
  }

  initJeeliz() {
    // Jeelizを初期化
    JEEFACETRANSFERAPI.init({
      canvasId: 'jeefacetransferCanvas',
      NNCpath: '../../assets/js/',
      videoSettings: {
          deviceId: 'default'
      },
      callbackReady: errCode => {
          if (errCode) {
              console.log('AN ERROR HAPPENS. ERROR CODE =', errCode);
              // 画面遷移時のエラー対応用、要修正
              if (errCode === 'ALREADY_INITIALIZED') {
              }
              return;
          }
          JEEFACETRANSFERAPI.switch_displayVideo(false);
          // console.log('Jeeliz is Ready');

          this.isJeelizReady = true;
      }
    });
  }

  initVrm() {
    // WebGLレンダラーの準備
    const renderer = new THREE.WebGLRenderer();
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setPixelRatio( window.devicePixelRatio );
    this.video.nativeElement.appendChild( renderer.domElement );

    // THREEカメラの準備
    // アバターの肩から上に照準が合うように視点とポジションの数値を設定
    const camera = new THREE.PerspectiveCamera( 6, window.innerWidth / window.innerHeight, 0.1, 20.0 );
    camera.position.set( 0.0, 1.47, 4.1 );

    // THREEシーンの準備、背景色の設定
    const scene = new THREE.Scene();
    scene.background = new THREE.Color( 0xf8d8d7 );

    // THREEライトの設定
    const light = new THREE.DirectionalLight( 0xffffff );
    light.position.set( 1.0, 1.0, 1.0 ).normalize();
    scene.add( light );

    // GLTFローダーの準備、VRMモデルの読み込み
    const loader = new GLTFLoader();
    loader.crossOrigin = 'anonymous';
    loader.load(
      this.models[this.avatar],
      ( gltf ) => {
        VRM.from( gltf ).then( ( vrm ) => {
          scene.add( vrm.scene );
          this.currentVrm = vrm;
          vrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.Hips ).rotation.y = Math.PI;
          vrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.LeftUpperArm ).rotation.z = -150;
          vrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.RightUpperArm ).rotation.z = 150;
          this.isModelLoaded = true;
          // console.log( vrm );
        } );
      },
      ( progress ) => {
        // console.log( 'Loading model...', 100.0 * ( progress.loaded / progress.total ), '%' )
      },
      ( error ) => console.error( error )
    );

    // アバターをrequestAnimationFrameで描画
    const clock = new THREE.Clock();

    const animate = () => {
      requestAnimationFrame( animate );
      const deltaTime = clock.getDelta();
      if ( this.currentVrm && this.isJeelizReady ) {
        // Jeelizから表情・モーションデータを取得
        const face = JEEFACETRANSFERAPI.get_morphTargetInfluencesStabilized();
        let rotation = JEEFACETRANSFERAPI.get_rotationStabilized();
        // 目の綴じ具合の調整
        if (face[8] === 1 || face[9] === 1) {
          face[8] = 1;
          face[9] = 1;
        } else {
          if (face[8] < 0.9) {
            face[8] = 0;
          }
          if (face[9] < 0.9) {
            face[9] = 0;
          }
        }
        // 表情認識設定
        this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.BlinkL, face[8] );
        this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.BlinkR, face[9] );
        this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.A, face[6] );
        this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.I, face[10] );
        // 表情認識が外れている場合は表情を反映しない
        if (rotation[2] !== 0) {
          // 顔の向き設定
          const head = this.currentVrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.Head ); // VRMのHeadを取得
          rotation = [
            (head.rotation._x + -rotation[0]) * 0.5,
            (head.rotation._y + rotation[1]) * 0.5,
            (head.rotation._z + -rotation[2]) * 0.5,
          ];
          // 閾値の設定
          // xは0.1~-0.7, yは-0.5~0.5, zは-0.3~0.3
          if (rotation[0] > 0.1) {
            rotation[0] = 0.1;
          } else if (rotation[0] < -0.7) {
            rotation[0] = -0.7;
          }
          if (rotation[1] > 0.5) {
            rotation[1] = 0.5;
          } else if (rotation[1] < -0.5) {
            rotation[1] = -0.5;
          }
          if (rotation[2] > 0.3) {
            rotation[2] = 0.3;
          } else if (rotation[2] < -0.3) {
            rotation[2] = -0.3;
          }
          // // 閾値の設定2
          // // 値が0.2以上変化している場合は、値の変化を0.2または-0.2にまるめる
          // if ((head.rotation._x - rotation[0]) > 0.2) {
          //   // console.log('trueX');
          //   rotation[0] = head.rotation._x - 0.2;
          // } else if ((head.rotation._x - rotation[0]) < -0.2) {
          //   rotation[0] = head.rotation._x + 0.2;
          // }
          // if ((head.rotation._y - rotation[1]) > 0.2) {
          //   // console.log('trueY');
          //   rotation[1] = head.rotation._y - 0.2;
          // } else if ((head.rotation._y - rotation[1]) < -0.2) {
          //   rotation[1] = head.rotation._y + 0.2;
          // }
          // if ((head.rotation._z - rotation[2]) > 0.2) {
          //   rotation[2] = head.rotation._z - 0.2;
          //   // console.log('trueZ');
          // } else if ((head.rotation._z - rotation[2]) < -0.2) {
          //   rotation[2] = head.rotation._z - 0.2;
          // }
          head.rotation.set( rotation[0], rotation[1], rotation[2], 'ZXY' );
        }

        this.currentVrm.update( deltaTime );
      }
      renderer.render( scene, camera );
    };

    animate();
    // console.log(VRMSchema.BlendShapePresetName);
  }

  confirm() {
    // this.auth.updateUserData({
    //     uid: this.auth.user.uid,
    //     avatar: true,
    //     profile: {
    //       vrm: {
    //         filename: this.models[this.avatar],
    //         url: this.models[this.avatar]
    //       },
    //       modelType: 'vrm'
    //     }
    //   }).then(() => {
      // console.log('userUpdated');
      const result = window.confirm('アバター通話の動作確認を開始します。ハウリング防止の為、イヤホンまたはヘッドホンを付けてご利用ください。');
      if (result) {
        this.router.navigate(['/avatar/call-test', {avatar: this.avatar}]);
      }
    // });
  }

  ngOnDestroy() {
    location.reload();
  }

}
